import * as React from 'react';
const SvgCollapse = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.293 1.293a1 1 0 111.414 1.414l-2.944 2.944A10 10 0 0114 7.055v.291l.39-.09A10 10 0 0116.64 7h.861a1 1 0 110 2l-5-.003a1.5 1.5 0 01-1.5-1.5V2.5a1 1 0 112 0v.861c0 .757-.086 1.511-.256 2.25l-.09.39h.295a9.994 9.994 0 011.411-1.776l2.933-2.932zM6 12.653v.292c-.638.4-1.23.87-1.763 1.404l-2.944 2.944a1 1 0 101.414 1.414l2.933-2.932A10 10 0 007.05 14h.296l-.09.39A10 10 0 007 16.64v.861a1 1 0 102 0v-4.997a1.5 1.5 0 00-1.5-1.5L2.5 11a1 1 0 100 2h.861c.757 0 1.511-.086 2.25-.256l.39-.09z"
            fill="currentColor"
        />
    </svg>
);
export default SvgCollapse;
